import apiFetch from '../../apiFetch'

export default function (idVisita, token) {
  return apiFetch({endPoint: `Visita/imprimirInforme?idVisita=` + idVisita, method: 'GET', body: null, token: token})
}